import React from "react";
// css comes in libraryBox.css in hw

const OpenLibraryMcq = ({ sQuestion, questionNumber }) => {
  return (
    <>
      <div className="mt-3 library_mcq_box">
        <span className="library_mcq_question ">
          Q{questionNumber + 1}. {sQuestion?.title}
        </span>
        {<div style={{ fontSize: "15px" }}>{sQuestion?.question?.domain?.name || '-'} | {sQuestion?.question?.skill?.name || '-'} | {sQuestion?.question?.type?.name || '-'} | {sQuestion?.question?.difficulty_level?.name || '-'} |
          {" " + sQuestion?.question?.book?.name || '-'} : {sQuestion?.question?.chapter?.chapterName || '-'}
        </div>}
        <div className="mt-3 ms-4 ">
          <ul>
            {sQuestion?.options?.length > 0 &&
              sQuestion?.options?.map((option, index) => (
                <li key={index} className="library_mcq_option">
                  {option?.key + " "} - {option?.value}
                </li>
              ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default OpenLibraryMcq;
